import React from 'react';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';
import { FlexColumn } from 'ui-components/components/flex';
import style from '../engagement-card.module.less';

export const ShippingWithConnectBody = () => {
  return (
    <FlexColumn>
      <Text className={style['card-text']} textType={TextType.Paragraph} value={messages.printingWithConnectLineOne} />
      <Text className={style['card-text']} textType={TextType.Paragraph} value={messages.printingWithConnectLineTwo} />
    </FlexColumn>
  );
};
